/* lua.js generated code 0.3.0 */
var PushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")

let CountDownCmpt = require("clover/panel/component/common/CountDownCmpt");
var MonthTicketTryPanel = xClass("MonthTicketTryPanel", BasePanel, function () {
    // return cc.CSLoader.createNode("cocos/lightning_rush_explain.csb")
    return cc.Node.create()
    // return cc.CSLoader.createNode("cocos/champion_champion_main.csb")
})
MonthTicketTryPanel.resource = [
    "packed/MonthTicketTry.pack"

]
const MonthTicketManager = require("./MonthTicketManager");


MonthTicketTryPanel.show = function (closeCb,entry) {
    function onSuccess() {
        MonthTicketTryPanel.create(closeCb,entry)
    }
    preloadWithLoading(MonthTicketTryPanel.resource, onSuccess, function () {
        Toast.make(getText("error.tip.load_res_error"))
        closeCb && closeCb()
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
        closeCb && closeCb()
    })
}
MonthTicketTryPanel.prototype.ctor = function (closeCb,entry) {
    var self = this;
    // console.log("adstart adreward", adStartReward)
    BasePanel.prototype.ctor.call(self)
    self.entry = entry;

    this.mgr = MonthTicketManager.getInstance();
    self.session = DCAssist.dc4ShowCashGoods(ModuleName.MONTH_TICK, self.entry ? self.entry : "main", this.mgr.getGoodsIds([MonthTicketConst.try]))
    self.mgr.dcTryPageShow()

    self.closeCb = closeCb
    self.fitScreen()
    self.initUI()
    // self.popup(null,null,null,null,null,250);
    self.mgr.tryPanel = self;
    self.popup()
}

MonthTicketTryPanel.prototype.initUI = function () {
    let self = this;
    this.mgr = MonthTicketManager.getInstance();

    self.mainNode = cc.CSLoader.createNode("cocos/ticket_ticket_try.csb")
    self.addChild(self.mainNode);

    let closeBtn = UIButton.create(self.mainNode.getChildByName("com_close"));
    PushBounceAnim.create(closeBtn)
    closeBtn.on(UIButtonEvent.Click, () => {
        if (self.isBusy) {
            return
        }
        self.isBusy = true
        self.onClose()
    })
    self.buyBtn = UIButton.create(self.mainNode.getChildByName("btn_buy"));
    PushBounceAnim.create(self.buyBtn)
    self.buyBtn.on(UIButtonEvent.Click, () => {
        self.buy()
    })

    self.helpBtn = UIButton.create(self.mainNode.getChildByName("com_detail"));
    PushBounceAnim.create(self.helpBtn)
    self.helpBtn.on(UIButtonEvent.Click, () => {
        if (self.isBusy) {
            return
        }
        self.isBusy = true
        self.mgr.dcMonthTicketNormal("trial_double_check_click", self.mgr.getDCSession(), {
            click_type: "note"
        })
        ActivityCommon.showExplain(() => {
            self.isBusy = false
            self.mgr.dcMonthTicketNormal("trial_note_show")
        }, {
            text: getText("monthcard.illustrate.text3"),
            title: "说明"

        })
    })

    let dailyRewards = self.mgr.getDailyRewards()

    for (let i = 0; i < 4; i++) {
        let node = self.mainNode.getChildByName("ticket_iconbg_org" + (i + 1))
        let reward = dailyRewards[i]
        node.setVisible(reward)
        if (reward) {
            self.initRewardUI(node, reward)
        }

    }

    self.animateNode =  self.mainNode.getChildByName("ticke_buy_animate")
    let bgAnimNode = sp.SkeletonAnimation.create("spine/ylyp_star.skel","spine/ylyp_star.atlas",1)
    bgAnimNode.setAnimation(0, "animation", true)
    self.animateNode.addChild(bgAnimNode)
    bgAnimNode.y = - 210



    let rewardNode = self.mainNode.getChildByName("ticket_iconbg_org5")
    // let tryReward = {itemId:14,num:10}
    let tryGood = self.mgr.getGoodMeta(MonthTicketConst.try)
    self.initRewardUI(rewardNode, tryGood.items[1])
    self.buyBtn.getChildByName("label").setString(`￥${tryGood.getRmb()/100}购买`)
    TTUtil.addTTIcon(self.buyBtn.getChildByName("label"), tryGood.getRmb()/100,{
        format: "{price}购买",
        icon_scale: 1.5
    })

    self.mainNode.getChildByName("label3").ignoreContentAdaptWithSize(true)
    self.mainNode.getChildByName("label1").ignoreContentAdaptWithSize(true)

    self.mainNode.getChildByName("label2").ignoreContentAdaptWithSize(true)
    self.mainNode.getChildByName("label1").y = -190
    self.mainNode.getChildByName("label2").y = -190


}

MonthTicketTryPanel.prototype.buy = function () {
    let self = this;
    if (self.isBusy) return
    self.isBusy = true
 

    function onSuccess(isClose) {
        self.isBusy = false
        if (isClose) {
            // self.mgr.info.trialBuyTs = 1 //测试代码
            self.onClose()
        }
    }

    function onFail(evt) {
        self.isBusy = false
    }
    // let productId = self.mgr.getProductId(MonthTicketConst.try)

    self.mgr.buy(MonthTicketConst.try, onSuccess, onFail, onFail, ModuleName.MONTH_TICK, {
        session: self.session,
        scence: ModuleName.MONTH_TICK,
        entry: self.entry ? self.entry : "main",
    })

}
MonthTicketTryPanel.prototype.updateUI = function () {

}
MonthTicketTryPanel.prototype.initRewardUI = function (node, reward) {
    let icon = UIItemBuilder.createProp(reward.itemId, reward.num, null, true, true)[0]
    icon.scale = 0.6
    node.getChildByName("icon").addChild(icon)
    let label = node.getChildByName("label")
    label.y = 12
    label.setString("x" + reward.num)
}
MonthTicketTryPanel.prototype.onClose = function (cb) {
    let self = this;
    self.mgr.tryPanel = null;
    self.closeCb && self.closeCb()
    BasePanel.prototype.onClose.call(self, cb);

}
MonthTicketTryPanel.prototype.onCleanup = function () {
    let self = this;
    ResManager.release(MonthTicketTryPanel.resource)
}
/**
 * UI适配屏幕分辨率
 */
MonthTicketTryPanel.prototype.fitScreen = function () {
    var self = this
    var scaleY = display.height / GamePlayConfig_Design_Height
    var scaleX = display.width / GamePlayConfig_Design_Width


    var scale = Math.min(scaleX, scaleY)
    cc.log("fitScreen", scale)
    self._scale = scale
    self.setScale(self._scale)


}
module.exports = MonthTicketTryPanel;